import type { SymbolLayerSpecification } from "mapbox-gl";

type SymbolLayout = NonNullable<SymbolLayerSpecification["layout"]>;

const REMOTE_LABEL_FONT = "Averta Semibold";
// TinySDF lit la graisse dans le NOM du fontstack : « Semibold » y matcherait /bold/i → 900.
const LOCAL_LABEL_FONT = "Averta";

function mapLabelFont(localGlyphs: boolean): [string] {
  return [localGlyphs ? LOCAL_LABEL_FONT : REMOTE_LABEL_FONT];
}

// Nudges empiriques : TinySDF et le serveur de polices posent les glyphes sur des baselines
// différentes. En em, donc valables aux deux tailles de compteur (cluster 18, hexgrid 13).
function mapLabelOffset(localGlyphs: boolean): [number, number] {
  return localGlyphs ? [0, -0.066] : [0, 0.23];
}

export function mapCountTextField(countProperty: string | undefined): SymbolLayout["text-field"] {
  const field = countProperty ? ["to-string", ["get", countProperty]] : ["get", "point_count_abbreviated"];
  return field as SymbolLayout["text-field"];
}

export function mapCountLabelLayout(params: {
  localGlyphs: boolean;
  textField: SymbolLayout["text-field"];
  textSize: SymbolLayout["text-size"];
}): SymbolLayout {
  return {
    "text-field": params.textField,
    "text-font": mapLabelFont(params.localGlyphs),
    "text-size": params.textSize,
    "text-offset": mapLabelOffset(params.localGlyphs),
    "text-allow-overlap": true,
    "text-ignore-placement": true,
  };
}
